import React, { useEffect } from "react";
import "react-table-v6/react-table.css";
import "./OrderDetails.scss";
import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import {
  useHistory,
  //   useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import delivaApiService from "../../../common/services/apiService";
import Loader from "../../../Component/common/Loader";
import moment from "moment";
import Footer from "../commonAdmin/Footer";
import CONSTANTS from "../../../common/helpers/Constants";
import Template from "../../../common/helpers/Template";
import CancelRequestOrderModal from "./CancelRequestOrderModal";

const OrderDetails = (props) => {
  const [showLoader, setShowLoader] = React.useState(false);
  const [requestDetails, setRequestDetails] = React.useState(null);
  const [showCancelRequest, setShowCancelRequest] = React.useState(false);
  const [cancelReason, setCancelReason] = React.useState("");

  // hooks
  const history = useHistory();
  //get order id from params
  const { id } = useParams();

  // Open Delivery Request Data
  const getOpenDeliveryRequestData = (id) => {
    delivaApiService("getOpenDeliveryRequestDetail", { orderId: id })
      .then((response) => {
        if (response?.data?.status === 200) {
          const data = response?.data?.resourceData;
          setRequestDetails(data);
          setShowLoader(false);
        }
      })
      .catch((error) => {
        setShowLoader(false);
        console.error("Failed to update status:", error);
      });
  };

  const handleRouteChange = (val) => {
    history.push(val);
  };

  const handleShowCancelRequest = () => {
    setShowCancelRequest(true);
  };

  const handleCloseCancelRequest = () => {
    setShowCancelRequest(false);
  };

  useEffect(() => {
    if (id) {
      setRequestDetails(null);
      setShowLoader(true);
      getOpenDeliveryRequestData(id);
    }
  }, [id]);

  const formatPhoneNumber = (num) => {
    // Remove all non-digits except +
    num = num.replace(/[^+\d]/g, "");

    // Extract country code (+234) and remaining digits
    const country = num.slice(0, 4); // +234
    const rest = num.slice(4); // 5868658565

    // Format groups: 3 - 3 - 4
    const part1 = rest.slice(0, 3);
    const part2 = rest.slice(3, 6);
    const part3 = rest.slice(6);

    return `${country} ${part1} ${part2} ${part3}`;
  };

  const orderStatus = (status) => {
    if (status === CONSTANTS.ORDER_STATUS.TRANSIT) {
      return "In transit";
    } else if (status === CONSTANTS.ORDER_STATUS.ACCEPTED) {
      return "Accepted bid";
    } else if (status === CONSTANTS.ORDER_STATUS.DELIVERED) {
      return "Delivered";
    } else if (status === CONSTANTS.ORDER_STATUS.CANCELLED) {
      return "Cancelled";
    } else if (status === CONSTANTS.ORDER_STATUS.REJECTED) {
      return "Pickup rejected";
    }
  };

  const handleCancelReason = (reason) => {
    setCancelReason(reason);
  };

  const cancelDeliveryOrder = () => {
    setShowLoader(true);
    delivaApiService("cancelDeliveryRequest", {
      requestId: id,
      deliveryRequestReason: [cancelReason],
      canceled: true,
    })
      .then((response) => {
        if (response?.data?.status === 200) {
          handleCloseCancelRequest();
          handleRouteChange("/orders/pickup");
        }
        setShowLoader(false);
      })
      .catch((error) => {
        setShowLoader(false);
        console.error("Failed to update status:", error);
      });
  };

  return (
    <div className="page__wrapper h-100">
      <Header {...props} />
      <div className="mainContainer CustomerTable">
        <Row noGutters className="h-100">
          <Sidebar {...props} />
          <Col md={9} lg={10} className="boxTyp3">
            <Container fluid>
              <div className="content-wrapper">
                <section className="d-flex justify-content-between align-items-center gap-1 mb-4">
                  <div className="w-100">
                    <h3 className="font-weight-normal mb-0 line-ht color-33 fs-24">
                      Order Details
                    </h3>
                    <h5 className="font-weight-normal mb-0 line-ht color-head">
                      <span
                        className="pointer"
                        onClick={() => {
                          let route;

                          switch (props.match.params.name) {
                            case "total":
                              route = "/orders/total";
                              break;
                            case "pickup":
                              route = "/orders/pickup";
                              break;
                            case "intransit":
                              route = "/orders/intransit";
                              break;
                            case "cancelled":
                              route = "/orders/cancelled";
                              break;
                            case "delivered":
                              route = "/orders/delivered";
                              break;
                            default:
                              route = "/orders/total";
                              // let daId = this.state.details?.daId;
                              // route = `/deliveryPartnerOrders/totalorders/${daId}`;
                              // Handle cases for other order statuses or provide a default route
                              break;
                          }

                          handleRouteChange(route);
                        }}
                      >
                        {props.match.params.name === "total"
                          ? "Total Orders"
                          : props.match.params.name === "intransit"
                            ? "In Transit Orders"
                            : props.match.params.name === "pickup"
                              ? "Accepted Orders"
                              : props.match.params.name === "cancelled"
                                ? "Cancelled Orders"
                                : props.match.params.name === "delivered"
                                  ? Template.COMPLETEDORDERS
                                  : "Total Orders"}
                      </span>
                      <span className="icon-next mx-2 fs12"></span>
                      <span className="pointer">{"Order details"} </span>
                    </h5>
                  </div>
                  {(requestDetails?.status === "Accepted bid" ||
                    requestDetails?.status ===
                      CONSTANTS.ORDER_STATUS.ACCEPTED) && (
                    <button
                      className="df-button danger cancel-red-btn"
                      onClick={handleShowCancelRequest}
                    >
                      {"Cancel Order"}
                    </button>
                  )}
                </section>
                <section className="details-wrap mb-4">
                  <Row noGutters>
                    <Col md={12} lg={12}>
                      <>
                        <h5 className="px-3 px-md-4">{"Package details"}</h5>
                        <hr />
                      </>
                    </Col>
                  </Row>
                  <>
                    <Row className="px-3 px-md-4 package-details-row">
                      <Col xs={12} md={6} lg={4} className="mb-4 col-pkg">
                        <h5 className="font-weight-normal color-grey fs18 text-nowrap">
                          Title
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.title ? requestDetails?.title : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={4} className="mb-4 col-pkg">
                        <h5 className="font-weight-normal color-grey fs18 text-nowrap">
                          Weight
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.weight
                            ? requestDetails?.weight
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={4} className="mb-4 col-pkg">
                        <h5 className="font-weight-normal color-grey fs18 text-nowrap">
                          Package Value
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.value
                            ? `${
                                requestDetails?.currency ===
                                CONSTANTS.CURRENCY.USD
                                  ? "$"
                                  : requestDetails?.currency ===
                                      CONSTANTS.CURRENCY.NGN
                                    ? "₦"
                                    : null
                              }${requestDetails?.value}`
                            : "--"}
                        </p>
                      </Col>

                      <Col xs={12} md={6} lg={4} className="mb-4 col-pkg">
                        <h5 className="font-weight-normal color-grey fs18 text-nowrap">
                          Offer Amount
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.bidAmount
                            ? `${
                                requestDetails?.currency ===
                                CONSTANTS.CURRENCY.USD
                                  ? "$"
                                  : requestDetails?.currency ===
                                      CONSTANTS.CURRENCY.NGN
                                    ? "₦"
                                    : null
                              }${requestDetails?.bidAmount}`
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={4} className="mb-4 col-pkg">
                        <h5 className="font-weight-normal color-grey fs18 text-nowrap">
                          Accepted Bid Amount
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.acceptedBidAmount
                            ? `${
                                requestDetails?.currency ===
                                CONSTANTS.CURRENCY.USD
                                  ? "$"
                                  : requestDetails?.currency ===
                                      CONSTANTS.CURRENCY.NGN
                                    ? "₦"
                                    : null
                              }${requestDetails?.acceptedBidAmount}`
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={4} className="mb-4 col-pkg">
                        <h5 className="font-weight-normal color-grey fs18 text-nowrap">
                          Transaction Amount
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.transactionAmount
                            ? `${
                                requestDetails?.currency ===
                                CONSTANTS.CURRENCY.USD
                                  ? "$"
                                  : requestDetails?.currency ===
                                      CONSTANTS.CURRENCY.NGN
                                    ? "₦"
                                    : null
                              }${requestDetails?.transactionAmount}`
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={12} lg={12} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Package Preview
                        </h5>
                        <div className="mt-4 d-flex flex-wrap gap-3">
                          {requestDetails?.requestMediaUrls?.map(
                            (imageObj, idx) => {
                              return (
                                <div
                                  style={{ width: "100%", maxWidth: "140px" }}
                                  key={idx}
                                >
                                  <Card
                                    className="card-id mb-4"
                                    style={{
                                      width: "100%",
                                      height: "140px",
                                    }}
                                  >
                                    <Card.Body>
                                      <Image
                                        className="img-fluid"
                                        width={140}
                                        height={140}
                                        src={imageObj?.originalMediaUrl}
                                      />
                                    </Card.Body>
                                  </Card>
                                </div>
                              );
                            },
                          )}
                        </div>
                      </Col>
                    </Row>
                  </>
                </section>
                <section className="details-wrap mb-4">
                  <Row noGutters>
                    <Col md={12} lg={12}>
                      <>
                        <h5 className="px-3 px-md-4">{"Order details"}</h5>
                        <hr />
                      </>
                    </Col>
                  </Row>
                  <>
                    <Row className="px-3 px-md-4">
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Request ID
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.requestId
                            ? `#${requestDetails?.requestId}`
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Order date
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.orderDate
                            ? moment(requestDetails?.orderDate).format(
                                "DD MMM YYYY",
                              )
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4 ReactTable">
                        <h5 className="font-weight-normal color-grey fs18">
                          Status
                        </h5>
                        <p
                          className={`fs18 font-weight-500 mb-0 ${
                            orderStatus(requestDetails?.status) === "Delivered"
                              ? "text-green"
                              : orderStatus(requestDetails?.status) ===
                                  "In transit"
                                ? "text-orange"
                                : "text-red"
                          }`}
                        >
                          {requestDetails?.status
                            ? orderStatus(requestDetails?.status)
                            : "--"}
                        </p>
                      </Col>
                      {requestDetails?.status !==
                        CONSTANTS.ORDER_STATUS.DELIVERED &&
                        requestDetails?.status !==
                          CONSTANTS.ORDER_STATUS.CANCELLED && (
                          <Col xs={12} md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              {requestDetails?.status ===
                              CONSTANTS.ORDER_STATUS.ACCEPTED
                                ? `Pickup Code`
                                : `Drop off code`}
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {requestDetails?.status ===
                              CONSTANTS.ORDER_STATUS.ACCEPTED
                                ? requestDetails?.pickupCode
                                : requestDetails?.dropOffCode
                                  ? requestDetails?.dropOffCode
                                  : "--"}
                            </p>
                          </Col>
                        )}
                      <Col xs={12} md={6} lg={6} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Source
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.sourceLocation
                            ? requestDetails?.sourceLocation
                            : "--"}
                        </p>
                      </Col>

                      <Col xs={12} md={6} lg={6} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Destination
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.destinationLocation
                            ? requestDetails?.destinationLocation
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Pickup date
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.pickupDate
                            ? moment(requestDetails?.pickupDate).format(
                                "DD MMM YYYY",
                              )
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Pickup time
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.pickupTime
                            ? moment(requestDetails?.pickupTime).format(
                                "h:mm A",
                              )
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Expected delivery date
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.expectedDeliveryDate
                            ? moment(
                                requestDetails?.expectedDeliveryDate,
                              ).format("DD MMM YYYY")
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Expected delivery time
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.expectedDeliveryTime
                            ? moment(
                                requestDetails?.expectedDeliveryTime,
                              ).format("h:mm A")
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={12} lg={12} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Additional Notes
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.description
                            ? requestDetails?.description
                            : "--"}
                        </p>
                      </Col>
                      {requestDetails?.orderCancelReason && (
                        <Col xs={12} md={12} lg={12} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Cancel Reason
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {requestDetails?.orderCancelReason
                              ? requestDetails?.orderCancelReason
                              : "--"}
                          </p>
                        </Col>
                      )}
                    </Row>
                  </>
                </section>
                <div className="d-flex gap-3 ">
                  <section className="details-wrap mb-4 flex-fill">
                    <Row noGutters>
                      <Col md={12} lg={12}>
                        <>
                          <h5 className="px-3 px-md-4">{"Sender details"}</h5>
                          <hr />
                        </>
                      </Col>
                    </Row>
                    <>
                      <Row className="px-3 px-md-4">
                        <Col xs={12} md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Sender name
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                            {requestDetails?.senderName
                              ? requestDetails?.senderName
                              : "--"}
                          </p>
                        </Col>
                        <Col xs={12} md={6} lg={7} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Sender Contact
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {requestDetails?.senderContact
                              ? formatPhoneNumber(requestDetails?.senderContact)
                              : "--"}
                          </p>
                        </Col>
                      </Row>
                    </>
                  </section>
                  {requestDetails?.pickupName && (
                    <section className="details-wrap mb-4 ml-2 flex-fill">
                      <Row noGutters>
                        <Col md={12} lg={12}>
                          <>
                            <h5 className="px-3 px-md-4">{"Pickup details"}</h5>
                            <hr />
                          </>
                        </Col>
                      </Row>
                      <>
                        <Row className="px-3 px-md-4">
                          <Col xs={12} md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Pickup Name
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                              {requestDetails?.pickupName
                                ? requestDetails?.pickupName
                                : "--"}
                            </p>
                          </Col>
                          <Col xs={12} md={6} lg={7} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Pickup Contact
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {requestDetails?.pickupMobile
                                ? formatPhoneNumber(
                                    requestDetails?.pickupMobile,
                                  )
                                : "--"}
                            </p>
                          </Col>
                        </Row>
                      </>
                    </section>
                  )}
                </div>
                <section className="details-wrap mb-4">
                  <Row noGutters>
                    <Col md={12} lg={12}>
                      <>
                        <h5 className="px-3 px-md-4">{"Receiver details"}</h5>
                        <hr />
                      </>
                    </Col>
                  </Row>
                  <>
                    <Row className="px-3 px-md-4">
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Receiver name
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.receiverName
                            ? requestDetails?.receiverName
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Receiver Contact
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.receiverContactNo
                            ? formatPhoneNumber(
                                requestDetails?.receiverContactNo,
                              )
                            : "--"}
                        </p>
                      </Col>
                    </Row>
                  </>
                </section>
                {!requestDetails?.delegate ? (
                  requestDetails?.partnerCode && (
                    <section className="details-wrap mb-4">
                      <Row noGutters>
                        <Col md={12} lg={12}>
                          <>
                            <h5 className="px-3 px-md-4">
                              {"Delivery partner details"}
                            </h5>
                            <hr />
                          </>
                        </Col>
                      </Row>
                      <>
                        <Row className="px-3 px-md-4">
                          <Col xs={12} md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Partner Code
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                              {requestDetails?.partnerCode
                                ? `#${requestDetails?.partnerCode}`
                                : "--"}
                            </p>
                          </Col>
                          <Col xs={12} md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Name
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {requestDetails?.partnerName
                                ? requestDetails?.partnerName
                                : "--"}
                            </p>
                          </Col>
                          <Col xs={12} md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Contact
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {requestDetails?.partnerContact
                                ? formatPhoneNumber(
                                    requestDetails?.partnerContact,
                                  )
                                : "--"}
                            </p>
                          </Col>
                          <Col xs={12} md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Address
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {requestDetails?.partnerAddress
                                ? requestDetails?.partnerAddress
                                : "--"}
                            </p>
                          </Col>
                        </Row>
                      </>
                    </section>
                  )
                ) : (
                  <div className=" mb-4">
                    <h5 className="fs-24 font-weight-normal mb-3">
                      {"Delivery partner details "}
                      <span className="green-color">(Delegated request)</span>
                    </h5>

                    <div className="mt-1">
                      <Row>
                        {/* Bidding DP */}
                        {requestDetails?.partnerCode && (
                          <Col xs={12} md={6} className="mb-4">
                            <section className="details-wrap h-100">
                              <Row noGutters>
                                <Col md={12}>
                                  <h5 className="px-3 px-md-4">
                                    {"Bidding DP"}
                                  </h5>
                                  <hr />
                                </Col>
                              </Row>
                              <Row className="px-3 px-md-4">
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Partner Code
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                                    {requestDetails?.partnerCode
                                      ? `#${requestDetails?.partnerCode}`
                                      : "--"}
                                  </p>
                                </Col>
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Name
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600">
                                    {requestDetails?.partnerName
                                      ? requestDetails?.partnerName
                                      : "--"}
                                  </p>
                                </Col>
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Contact
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600">
                                    {requestDetails?.partnerContact
                                      ? formatPhoneNumber(
                                          requestDetails?.partnerContact,
                                        )
                                      : "--"}
                                  </p>
                                </Col>
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Address
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600">
                                    {requestDetails?.partnerAddress
                                      ? requestDetails?.partnerAddress
                                      : "--"}
                                  </p>
                                </Col>
                              </Row>
                            </section>
                          </Col>
                        )}
                        {/* Delegate only pickup */}
                        {requestDetails?.pickup && (
                          <Col xs={12} md={6} className="mb-4">
                            <section className="details-wrap h-100">
                              <Row noGutters>
                                <Col md={12}>
                                  <h5 className="px-3 px-md-4">
                                    {"Delegate only pickup"}
                                  </h5>
                                  <hr />
                                </Col>
                              </Row>
                              <Row className="px-3 px-md-4">
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Partner Code
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                                    {requestDetails?.pickup?.id
                                      ? `#${requestDetails?.pickup?.id}`
                                      : "--"}
                                  </p>
                                </Col>
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Name
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600">
                                    {requestDetails?.pickup?.name
                                      ? requestDetails?.pickup?.name
                                      : "--"}
                                  </p>
                                </Col>
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Contact
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600">
                                    {requestDetails?.pickup?.contactNo
                                      ? formatPhoneNumber(
                                          requestDetails?.pickup?.contactNo,
                                        )
                                      : "--"}
                                  </p>
                                </Col>
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Address
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600">
                                    {requestDetails?.pickup?.address
                                      ? requestDetails?.pickup?.address
                                      : "--"}
                                  </p>
                                </Col>
                              </Row>
                            </section>
                          </Col>
                        )}
                        {/* Delegate Dropoff */}
                        {requestDetails?.dropOff && (
                          <Col xs={12} md={6} className="mb-3">
                            <section className="details-wrap h-100">
                              <Row noGutters>
                                <Col md={12}>
                                  <h5 className="px-3 px-md-4">
                                    {"Delegate Dropoff"}
                                  </h5>
                                  <hr />
                                </Col>
                              </Row>
                              <Row className="px-3 px-md-4">
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Partner Code
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                                    {requestDetails?.dropOff?.id
                                      ? `#${requestDetails?.dropOff?.id}`
                                      : "--"}
                                  </p>
                                </Col>
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Name
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600">
                                    {requestDetails?.dropOff?.name
                                      ? requestDetails?.dropOff?.name
                                      : "--"}
                                  </p>
                                </Col>
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Contact
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600">
                                    {requestDetails?.dropOff?.contactNo
                                      ? formatPhoneNumber(
                                          requestDetails?.dropOff?.contactNo,
                                        )
                                      : "--"}
                                  </p>
                                </Col>
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Address
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600">
                                    {requestDetails?.dropOff?.address
                                      ? requestDetails?.dropOff?.address
                                      : "--"}
                                  </p>
                                </Col>
                              </Row>
                            </section>
                          </Col>
                        )}
                        {/* Assigned transporter */}
                        {requestDetails?.transport && (
                          <Col xs={12} md={6} className="mb-3">
                            <section className="details-wrap h-100">
                              <Row noGutters>
                                <Col md={12}>
                                  <h5 className="px-3 px-md-4">
                                    {"Assigned transporter"}
                                  </h5>
                                  <hr />
                                </Col>
                              </Row>
                              <Row className="px-3 px-md-4">
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Partner Code
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                                    {requestDetails?.transport?.id
                                      ? `#${requestDetails?.transport?.id}`
                                      : "--"}
                                  </p>
                                </Col>
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Name
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600">
                                    {requestDetails?.transport?.name
                                      ? requestDetails?.transport?.name
                                      : "--"}
                                  </p>
                                </Col>
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Contact
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600">
                                    {requestDetails?.transport?.contactNo
                                      ? formatPhoneNumber(
                                          requestDetails?.transport?.contactNo,
                                        )
                                      : "--"}
                                  </p>
                                </Col>
                                <Col xs={6} className="mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Address
                                  </h5>
                                  <p className="fs18 font-weight-500 mb-0 gray-600">
                                    {requestDetails?.transport?.address
                                      ? requestDetails?.transport?.address
                                      : "--"}
                                  </p>
                                </Col>
                              </Row>
                            </section>
                          </Col>
                        )}
                      </Row>
                    </div>
                  </div>
                )}
                <Footer {...props} />
              </div>
            </Container>
          </Col>
        </Row>
      </div>
      <Loader showLoader={showLoader} />

      <CancelRequestOrderModal
        showCancelRequest={showCancelRequest}
        handleCloseCancelRequest={handleCloseCancelRequest}
        handleCancelReason={handleCancelReason}
        cancelDeliveryOrder={cancelDeliveryOrder}
      />
    </div>
  );
};

export default OrderDetails;
